import styled from 'styled-components'

import { helpers } from 'styles'

import { Container as SyntaxHighlightContainer } from 'components/SyntaxHighlighter/Container'

export const CodeBlock = styled.div`
	margin-top: -18px;
	padding-top: 24px;
	border: 1px solid ${helpers.color.border};
	border-radius: 4px;
	background-color: ${helpers.color.codeBlockBackground};

	> pre {
		margin: 0;
	}

	/* We unfortunately have to apply !important to the below properties to override the inline styling of the code element. */
	> pre > ${SyntaxHighlightContainer} > pre {
		border: none !important;
		margin: 0 !important;
	}
`
